export default __webpack_public_path__ + "static/media/one.9ac983ad.svg";